export default __webpack_public_path__ + "static/media/9.f8796cb5.svg";